import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import { Link, Redirect } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  activeUserAccount,
  resendUserActivationCode,
} from "../../../services/UserService";
import { AuthContext } from "../../../context/AuthProvider";
import Loading from "../../common/Loading/Loading";
import { checkRegistrationCode } from "../../../services/authService";
import "./index.css";
import { textAlign } from "@mui/system";

function AuthRedirectActivateAccountPage(props) {
  const { signInEmailAndPassword, loggedIn, setSingUpEmail } =
    useContext(AuthContext);

  const [error, setError] = useState(false);
  const [email, setEmail] = useState(
    props.location.state.userToActivate
      ? props.location.state.userToActivate.email
      : null
  );
  const [psw, setpsw] = useState(
    props.location.state.userToActivate
      ? props.location.state.userToActivate.senha
      : null
  );
  const [eventDetail, setEventDetails] = useState(
    props.location.state.event ? props.location.state.event : null
  );
  const [orderDetail, setOrderDetails] = useState(
    props.location.state.order ? props.location.state.order : null
  );
  const [firebase_id, setFirebase_id] = useState(
    props.location.state.userToActivate
      ? props.location.state.userToActivate.firebase_id
      : null
  );
  const [dashboard, setDashboard] = useState(
    props.location.state.dashboard ? props.location.state.dashboard : false
  );
  const [checkResponse, setCheckResponse] = useState(true);
  const [sendedCode, setSendedCode] = useState(false);
  const [wrongAnswer, setWrongAnswer] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [resendTimer, setResendTimer] = useState(60);

  useEffect(() => {
    if (wrongAnswer === "auth/wrong-password") {
      setRedirect(true);
    }
  }, []);

  useEffect(() => {
    let intervalId;

    if (resendTimer > 0) {
      intervalId = setInterval(() => {
        setResendTimer((prevTimer) => prevTimer - 1); // Atualiza o temporizador a cada segundo
      }, 1000);
    }

    return () => {
      clearInterval(intervalId); // Limpa o intervalo ao desmontar o componente
    };
  }, [resendTimer]);

  const [verificationCode, setVerificationCode] = useState({
    code1: null,
    code2: null,
    code3: null,
    code4: null,
  });
  const [loading, setLoading] = useState(false);

  const input1Ref = useRef();
  const input2Ref = useRef();
  const input3Ref = useRef();
  const input4Ref = useRef();

  // const handleInputChange = (currentInput, ref, code) => {
  //   if (currentInput === 1)
  //     setVerificationCode((prevState) => ({ ...prevState, code1: code }));
  //   if (currentInput === 2)
  //     setVerificationCode((prevState) => ({ ...prevState, code2: code }));
  //   if (currentInput === 3)
  //     setVerificationCode((prevState) => ({ ...prevState, code3: code }));
  //   if (currentInput === 4)
  //     setVerificationCode((prevState) => ({ ...prevState, code4: code }));
  //   ref.current.focus();
  // };

  const handleVerifyCode = async () => {
    setLoading(true);
    if (
      !verificationCode.code1 ||
      !verificationCode.code2 ||
      !verificationCode.code3 ||
      !verificationCode.code4
    ) {
      setError("Please, enter all codes.");
      setSendedCode(false);
      setCheckResponse(true);
    } else {
      setError(false);
      const payload = handleFormatData();
      const checkResponse = (await checkRegistrationCode(payload)).data.res;
      if (checkResponse) {
        handleLogin();
      }
      setCheckResponse(checkResponse);
    }
    setLoading(false);
  };

  const handleFormatData = () => {
    const payload = {
      firebase_id: firebase_id,
      code: `${verificationCode.code1}${verificationCode.code2}${verificationCode.code3}${verificationCode.code4}`,
    };
    return payload;
  };

  const handleLogin = async () => {
    try {
      const data = {
        email: email,
        senha: psw,
      };

      const res = await signInEmailAndPassword(data);
      if (res && res.code === "auth/wrong-password") {
        setWrongAnswer(res.code);
        setSingUpEmail("redirect");
        setSendedCode(false);
        setCheckResponse(true);
      }
    } catch (error) {
      alert(error);
    }
  };

  // const resendCode = async () => {
  //   setLoading(true);
  //   setCheckResponse(true);
  //   setError(false);
  //   await resendUserActivationCode({
  //     email: email,
  //     uid: firebase_id,
  //   });
  //   setSendedCode(true);
  //   setLoading(false);
  // };

  const resendCode = async () => {
    setLoading(true);
    setCheckResponse(true);
    setError(false);
    await resendUserActivationCode({
      email: email,
      uid: firebase_id,
    });
    setSendedCode(true);
    setResendTimer(60); // Reinicia o temporizador ao reenviar o código
    setLoading(false);
  };

  const inputRefs = useRef([]);

  const handleKeyDown = (event, inputRef, index) => {
    if (event.key === "Backspace" || event.key === "Delete") {
      event.preventDefault();
      setInputValue("", index);
      if (index > 1) {
        inputRef[index - 2].focus();
      }
    }
  };

  const setInputValue = (value, index) => {
    const newVerificationCode = { ...verificationCode };
    newVerificationCode[`code${index}`] = value;
    setVerificationCode(newVerificationCode);
  };

  const handleInputChange = (event, inputRef, index) => {
    const { value } = event.target;
    setInputValue(value, index);
    if (index < inputRef.length) {
      inputRef[index].focus();
    }
  };

  return (
    <div
      className="main"
      style={{
        alignItems: "center",
        textAlign: "center",
      }}
    >
      {/* <HeaderComponent transparent={true} leftPress={() => props.navigation.goBack()} /> */}
      <div
        style={{
          paddingTop: 20,
          marginLeft: 10,
          marginRight: 10,
          paddingHorizontal: 5,
        }}
      >
        <div className="textTitle">Code Verification</div>
        <div style={{ textAlign: "center" }}>
          Enter the verification code that was sent to your email{" "}
          {/* <div className="userEmail">{props.route.params.email}</div> */}
        </div>
        <div
          style={{
            width: "100%",
            height: "auto",
            minHeight: "30%",
            marginTop: 20,
          }}
        >
          <div className="codeContainer">
            <input
              type="text"
              pattern="\d"
              value={verificationCode.code1}
              autoCapitalize="none"
              ref={(ref) => (inputRefs.current[0] = ref)}
              maxLength={1}
              className="code-input"
              onKeyDown={(event) => handleKeyDown(event, inputRefs.current, 1)}
              onChange={(event) =>
                handleInputChange(event, inputRefs.current, 1)
              }
            />
            <input
              type="text"
              pattern="\d"
              value={verificationCode.code2}
              autoCapitalize="none"
              ref={(ref) => (inputRefs.current[1] = ref)}
              maxLength={1}
              className="code-input"
              onKeyDown={(event) => handleKeyDown(event, inputRefs.current, 2)}
              onChange={(event) =>
                handleInputChange(event, inputRefs.current, 2)
              }
            />
            <input
              type="text"
              pattern="\d"
              value={verificationCode.code3}
              autoCapitalize="none"
              ref={(ref) => (inputRefs.current[2] = ref)}
              maxLength={1}
              className="code-input"
              onKeyDown={(event) => handleKeyDown(event, inputRefs.current, 3)}
              onChange={(event) =>
                handleInputChange(event, inputRefs.current, 3)
              }
            />
            <input
              type="text"
              pattern="\d"
              value={verificationCode.code4}
              autoCapitalize="none"
              ref={(ref) => (inputRefs.current[3] = ref)}
              maxLength={1}
              className="code-input"
              onKeyDown={(event) => handleKeyDown(event, inputRefs.current, 4)}
              onChange={(event) =>
                handleInputChange(event, inputRefs.current, 4)
              }
            />
          </div>
          {!loading && error.length >= 1 && (
            <div className="alertComponent">
              <span style={{ marginTop: "50px" }}>{error}</span>
            </div>
          )}
          {loading ? (
            <div style={{ marginTop: 30 }}>
              <Loading />
            </div>
          ) : !checkResponse ? (
            <div className="alertComponent">
              <span style={{ marginTop: "50px" }}>
                Incorrect Code. Try Again
              </span>
            </div>
          ) : (
            <div style={{ color: "green", marginTop: "10px" }}>
              {!loading && sendedCode ? (
                <span style={{ color: "green" }} className="alertComponent">
                  Sended Code{" "}
                </span>
              ) : null}
            </div>
          )}
        </div>
      </div>
      {wrongAnswer ? (
        <div className="alertComponent">
          <span style={{ marginTop: "50px", color: "green" }}>
            Verified Account. Re-login
          </span>
          {dashboard ? (
            <Link to="/login" className="">
              <div className="position-button">
                <button
                  onClick={() => handleVerifyCode()}
                  className="btn btn-primary"
                >
                  <span className="mediumWhiteText">Return to Login</span>
                </button>
              </div>
            </Link>
          ) : (
            <div className="position-button">
              <button
                onClick={() => props.onStateChange("signIn")}
                className="btn btn-primary"
              >
                <span className="mediumWhiteText">Ok</span>
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="position-button">
          <button
            onClick={() => handleVerifyCode()}
            className="btn btn-primary"
          >
            <span className="mediumWhiteText">VERIFY</span>
          </button>
        </div>
      )}
      <div>
        <span>Didn't receive the code?</span>
        <br />
        {resendTimer === 0 ? (
          <span className="resend-code-button-span" onClick={resendCode}>
            Click here
          </span>
        ) : (
          <span>
            Resend in {resendTimer} seconds
          </span>
        )}
      </div>

      {loggedIn && orderDetail && (
        <Redirect
          to={{
            pathname: `${process.env.PUBLIC_URL}/shop/checkout`,
            state: {
              event: eventDetail,
              order: orderDetail,
            },
          }}
        />
      )}
      {loggedIn && dashboard && <Redirect to="/shop/dashboard" />}
    </div>
  );
}

export default AuthRedirectActivateAccountPage;
